// @flow
import React from 'react';
import { Grid } from 'semantic-ui-react';

import { useIsUserAdmin } from '../../../custom-hooks/useIsUserAdmin';
import { TinyHeaderSpan } from '../../presentational/headings/TinyHeaderSpan';
import {
  getAdminOnlyDimensionFieldsFromMetricNameForEstimateCC,
  getMetricDimensionsLabelsFromMetricNameForEstimateCC,
  getNonDimensionFieldsFromMetricNameForEstimateCC,
  getNonDimensionFieldLabelsFromMetricNameForEstimateCC,
} from '../utils';

export const DimensionHeadersContainerForEstimateCC = ({ metricName }) => {
  const dimensionColumnWidth = 3;
  const nonDimensionColumnWidth = 2;
  const isUserAdmin = useIsUserAdmin();

  const dimensionLabels = getMetricDimensionsLabelsFromMetricNameForEstimateCC(metricName);
  const nonDimensionFields = getNonDimensionFieldsFromMetricNameForEstimateCC(metricName);
  const nonDimensionFieldLabels = getNonDimensionFieldLabelsFromMetricNameForEstimateCC(metricName);
  const adminOnlyFields = getAdminOnlyDimensionFieldsFromMetricNameForEstimateCC(metricName);

  const visibleNonDimensionFieldLabels = nonDimensionFieldLabels.filter((_, index) => {
    const fieldName = nonDimensionFields[index];

    // Admins can see all fields
    if (isUserAdmin) {
      return true;
    }

    // Non-admins should not see admin-only fields (e.g., Denser Bin Packing)
    return !adminOnlyFields.includes(fieldName);
  });

  return (
    <Grid.Row>
      {dimensionLabels.map((colName) => (
        <Grid.Column key={colName} width={dimensionColumnWidth}>
          <TinyHeaderSpan headerText={colName} />
        </Grid.Column>
      ))}
      {visibleNonDimensionFieldLabels.map((colName) => (
        <Grid.Column key={colName} width={nonDimensionColumnWidth}>
          <TinyHeaderSpan headerText={colName} />
        </Grid.Column>
      ))}
    </Grid.Row>
  );
};
